// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2pbYt","header":"ReportDetails_header__2wqL8","title":"ReportDetails_title__1zorw","left":"ReportDetails_left__1PeUy"};